import { render, staticRenderFns } from "./PaymentLoading.vue?vue&type=template&id=4927dfb7&scoped=true&lang=pug&"
import script from "./PaymentLoading.vue?vue&type=script&lang=js&"
export * from "./PaymentLoading.vue?vue&type=script&lang=js&"
import style0 from "./PaymentLoading.scss?vue&type=style&index=0&id=4927dfb7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4927dfb7",
  null
  
)

export default component.exports